import {
  IconAlignLeft,
  IconCircleDot,
  IconInfoCircle,
  IconListCheck,
  IconTextSize,
  IconUpload,
} from "@tabler/icons-react";
import type { TablerIcon } from "@tabler/icons-react";
import type { EcosystemHeadQuestionType } from "../../../../../../shared/ecosystemHeadQuestionnaire";

export type QuestionTypeMeta = {
  value: EcosystemHeadQuestionType;
  label: string;
  description: string;
  icon: TablerIcon;
};

export const QUESTION_TYPE_META: QuestionTypeMeta[] = [
  {
    value: "short_text",
    label: "Short text",
    description: "Single-line answer",
    icon: IconTextSize,
  },
  {
    value: "paragraph",
    label: "Long text",
    description: "Multi-line answer",
    icon: IconAlignLeft,
  },
  {
    value: "multiple_choice",
    label: "Multiple choice",
    description: "Pick one option",
    icon: IconCircleDot,
  },
  {
    value: "checkboxes",
    label: "Checkboxes",
    description: "Pick multiple options",
    icon: IconListCheck,
  },
  {
    value: "document_upload",
    label: "Document upload",
    description: "Upload a file or explain if unavailable",
    icon: IconUpload,
  },
  {
    value: "description",
    label: "Description",
    description: "Instructions or context",
    icon: IconInfoCircle,
  },
];

export const OPTION_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
